module.exports = __webpack_public_path__ + "static/media/aiitv1.8074aa77.jpg";